module.exports = __webpack_public_path__ + "static/img/about-list1.aa927b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about-list1.png
// module id = H+vX
// module chunks = 1